/**
 * Binary stock status logic:
 * stock > 0 -> In Stock
 * stock <= 0 -> No Stock
 */
export const getStockStatus = availableStock => {
  if (availableStock != null && Number(availableStock) > 0) {
    return { label: "In Stock", variant: "In Stock" };
  }
  return { label: "No Stock", variant: "Backorder" }; // Map No Stock to Red/Backorder status indicator style
};

export const isOutOfStock = availableStock => {
  return availableStock != null && Number(availableStock) <= 0;
};
